import React = require('react');

interface IToggleBtnProps {
	current_value : string;
	values : Array<IToggleBtnValues>;
	changed: Function;
}
interface IToggleBtnValues {
	name: string;
	value: string;
}

interface IToggleBtnState {
	changed: Function;
}

export default class ToggleBtn extends React.Component<IToggleBtnProps, IToggleBtnState>{

  	constructor(props:IToggleBtnProps){
  		super(props);
  		this.state = this.getInitState();
    }

	componentDidMount() {
	 	this.setState(this.getInitState());
	}

	protected getInitState():any{
		return {};
	}

	private toggleChangeHandler(evt, new_value): void {
		evt.preventDefault();
		this.props.changed(new_value);
	}

    render() {
		var values = this.props.values;
        var current_value = this.props.current_value;
        return (
			<div className="toggle_btn">
				{values.map((item:any) => {
					var class_name = '';
					if ( item.value === current_value) {
					    class_name = 'active';
					}
					return <a key={item.value} href="javascript:void(0);" className={ class_name } onClick={ (e) => {
						this.toggleChangeHandler(e,item.value);
					} }>{item.name}</a>;
				})}
			</div>
        );
    }
}



// WEBPACK FOOTER //
// ./lib/components/ToggleBtn.tsx